import React from "react";
import { theme } from "nectar-ui";
import { FaRegFolder } from "@react-icons/all-files/fa/FaRegFolder";
import { CustomLink } from "@pages/LawsuitPage/style";
import { Document } from "@customTypes/responses/document";
import { NormalText } from "@components/styles/dataDisplay";
import { useHistory } from "react-router-dom";

type AttachedLawsuitProps = {
  attachedCase: Document["case"];
};

const AttachedLawsuit: React.FC<AttachedLawsuitProps> = ({ attachedCase }) => {
  const history = useHistory();

  const handleLinkClick = () => {
    history.replace(`lawsuit/${attachedCase.id}`);
  };

  return (
    <div style={{ display: "flex", rowGap: 8, marginTop: 24, flexDirection: "column" }}>
      <div style={{ display: "flex", columnGap: 12, alignItems: "center" }}>
        <FaRegFolder size={16} color={theme.standard.colors.gray500} />
        <NormalText>
          Vinculado ao {`${attachedCase.type === "CTE_CASE" ? "caso" : "processo"}`}
        </NormalText>
      </div>
      <div style={{ marginLeft: 30 }}>
        <CustomLink to="" onClick={handleLinkClick}>
          {attachedCase.title}
        </CustomLink>
      </div>
    </div>
  );
};

export default AttachedLawsuit;
